import { render, staticRenderFns } from "./InputLabel.vue?vue&type=template&id=fe132a02&scoped=true"
import script from "./InputLabel.vue?vue&type=script&lang=ts"
export * from "./InputLabel.vue?vue&type=script&lang=ts"
import style0 from "./InputLabel.vue?vue&type=style&index=0&id=fe132a02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe132a02",
  null
  
)

export default component.exports